// ============================================
// Path: /frontend/src/components/ListingCard.jsx
// Purpose: Displays individual listing card with image, title, price
// UPDATED: Added WhatsApp share button + Mobile optimized styling
// ============================================

import { Link } from 'react-router-dom';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin } from 'lucide-react';
import ListingImage from './ListingImage';
import ShareOnWhatsAppButton from './whatsapp/ShareOnWhatsAppButton'; // ⭐ NEW IMPORT
import SaveListingButton from './listings/SaveListingButton';
import CompareButton from './listings/CompareButton';
import ChamaEligibleBadge from './listings/ChamaEligibleBadge';
import FreshnessLabel from './listings/FreshnessLabel';

export function ListingCard({ 
  id, 
  imageUrl, 
  imageHint, 
  title, 
  price, 
  location, 
  type,
  category = 'PROPERTY',  // ⭐ ADD THIS LINE
  isPromoted = false,
  createdAt,
  allowGroupBuy = false,
  chamaInterestCount = 0,
  initialBookmarked = null
}) {
  console.log('[ListingCard] Rendering card for:', { id, title, price, location, isPromoted });

  const href = `/listing/${id}`;

  return (
    <Card className="overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 h-full flex flex-col">
      <CardHeader className="p-0">
        <div className="relative aspect-[4/3] lg:h-36">
          {/* ⭐ WRAPPED IMAGE IN LINK */}
          <Link to={href} onClick={() => console.log('[ListingCard] Clicked listing:', id)}>
            <ListingImage
              src={imageUrl}
              alt={title}
              type={type}
              className="w-full h-full object-cover"
            />
          </Link>
          
          {isPromoted && (
            <div className="absolute top-1 right-1 sm:top-2 sm:right-2 bg-yellow-500 text-white text-[10px] sm:text-xs font-semibold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded shadow-md z-10">
              Featured
            </div>
          )}

          {/* Chama Badge - BOTTOM LEFT (stacked above freshness) */}
          {allowGroupBuy && 
          category === 'PROPERTY' && 
          price >= 50000000 && (
            <div className="absolute bottom-1 left-1 sm:bottom-2 sm:left-2 z-10">
              <ChamaEligibleBadge 
                listing={{ 
                  allowGroupBuy,
                  category: category,
                  subType: type,
                  title
                }} 
                showInterestCount={true} 
                interestCount={chamaInterestCount} 
                size="sm"
              />
            </div>
          )}

          {/* ⭐ NEW: WhatsApp Share Button */}
          <div className="absolute bottom-1 right-1 sm:bottom-2 sm:right-2 z-10">
            <ShareOnWhatsAppButton 
              listingId={id} 
              variant="icon"
              size="sm"
            />
          </div>
        </div>
      </CardHeader>
      
      {/* ⭐ WRAPPED CONTENT IN LINK */}
      <Link to={href} className="flex-grow flex flex-col">
        <CardContent className="p-2 sm:p-3 md:p-4 flex-grow">
          <Badge variant="outline" className="mb-1 sm:mb-2 text-[10px] sm:text-xs px-1.5 py-0.5">
            {type}
          </Badge>
          <CardTitle className="text-xs sm:text-sm md:text-base font-medium leading-tight mb-1 sm:mb-2 line-clamp-2">
            {title}
          </CardTitle>

<p className="text-xs sm:text-sm md:text-base font-bold text-primary">
  Ksh {Number(String(price).replace(/[^\d]/g, '')).toLocaleString()}
</p>
        </CardContent>
        <CardFooter className="p-2 sm:p-3 md:p-4 pt-0 flex flex-col gap-2">
        <div className="flex items-center text-[10px] sm:text-xs text-muted-foreground w-full">
          <MapPin className="w-3 h-3 sm:w-4 sm:h-4 mr-1 flex-shrink-0" />
          <span className="truncate">{location}</span>
        </div>
        
        {/* ⭐ NEW: Save & Compare Buttons */}
        <div className="flex gap-1 sm:gap-2 w-full">
          <SaveListingButton listingId={id} size="sm" className="flex-1" initialBookmarked={initialBookmarked} />
          <CompareButton listingId={id} size="sm" className="flex-1" />
        </div>
      </CardFooter>
      </Link>
    </Card>
  );
}